module.exports = __webpack_public_path__ + "static/media/pe.6fcc0ab2.svg";